export default __webpack_public_path__ + "static/media/map_middle-east.42b59655.png";